var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActivityThumbnails',{attrs:{"lesson-data":_vm.lessonData},on:{"on-prev":function($event){return _vm.$router.back()}}})}
var staticRenderFns = []

export { render, staticRenderFns }